import { format } from "date-fns";
import { useState } from "react";

import { Button } from "@/components/ui/button";
import { Calendar } from "@/components/ui/calendar";
import { cn } from "@/utils/cn";
import { IconCalendarEvent } from "@tabler/icons-react";
import { Drawer, DrawerContent, DrawerTrigger } from "./drawer";

interface DatePickerProps {
  selected: Date;
  onChange: (date: Date | undefined) => void;
}

export function DatePicker({ onChange, selected }: DatePickerProps) {
  const [isOpen, setIsOpen] = useState(false);

  const handleDateSelect = (date: Date | undefined) => {
    onChange(date);
    setIsOpen(false);
  };

  return (
    <Drawer open={isOpen} onClose={() => setIsOpen(false)}>
      <DrawerTrigger asChild>
        <Button
          variant="outline"
          className={cn(
            "justify-start text-left font-normal",
            !selected && "text-muted-foreground",
          )}
          onClick={() => setIsOpen(!isOpen)}
        >
          <IconCalendarEvent className="text-subinfo" />
          {selected ? (
            format(selected, "dd.MM.yyyy")
          ) : (
            <span>Datum auswählen</span>
          )}
        </Button>
      </DrawerTrigger>
      <DrawerContent className="min-h-[30rem] p-4">
        <Calendar
          selected={selected ?? new Date()}
          mode="single"
          onSelect={handleDateSelect}
          initialFocus
          className=""
        />
      </DrawerContent>
    </Drawer>
  );
}
